import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { logOperationActions } from './slice';
import capabilities from './capabilities';

export const ApiLogOperationGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logOperationActions.startLoading());
    }

    await gestopAPI
        .post('log/operations/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(logOperationActions.setList(response?.data?.list));
                    dispatch(logOperationActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(logOperationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logOperationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logOperationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogOperationCountCollection = async ({
    filters = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('log/operations/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLogOperationExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logOperationActions.startExporting());
    }

    await gestopAPI
        .post('log/operations/export', { exportType, format, columns, filters, orderBy, groupBy }, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logOperationActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logOperationActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logOperationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogOperationExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logOperationActions.startExporting());
    }

    await gestopAPI
        .get(`log/operations/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logOperationActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logOperationActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logOperationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogOperationGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logOperationActions.startLoading());
    }

    await gestopAPI
        .get(`log/operations/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(logOperationActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logOperationActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logOperationActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
